// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'analytics-neutral-solid';

export const Component = () => (
  <path d='M12.26 0C8.957 0 6.13 1.15 3.785 3.448 1.389 5.748.144 8.525 0 11.782h18.63l-4.693-4.789c-.24-.24-.24-.431 0-.67.239-.24.431-.24.67 0l5.556 5.555a.434.434 0 0 1 .143.335c0 .144-.047.24-.143.335l-5.556 5.604a.434.434 0 0 1-.335.143.434.434 0 0 1-.335-.143c-.24-.24-.24-.432 0-.67l4.693-4.742H0c.144 3.305 1.39 6.082 3.784 8.333 2.346 2.3 5.172 3.449 8.477 3.449 3.4 0 6.274-1.198 8.669-3.592 2.394-2.395 3.592-5.268 3.592-8.67 0-3.4-1.198-6.273-3.592-8.668C18.535 1.198 15.662 0 12.26 0Z' />
);

export const viewBox = '0 0 25 25';
